import React from "react";
import Home from "../Home/Home";
import About from "../About/About";
import Clients from "../Clients/Clients";
import Partners from "../Partners/Partners";
import Contact from "../Contact/Contact";
import Products from "../Products/Products";
import Features from "../Features/Features";
import "./main.css";

const Main = () => {
  return (
    <main className="main-container">
      <section id="home">
        <Home />
      </section>
      <section id="about">
        <About />
      </section>
      <section id="partners" className="no-min-height">
        <Partners />
      </section>
      <section id="features">
        <Features />
      </section>
      <section id="clients" className="no-min-height">
        <Clients />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <section id="products">
        <Products />
      </section>
    </main>
  );
};

export default Main;
